import React from 'react';
import { useIsRequiredElement } from '../../../hook/useIsRequiredElement';
import ElementErrorMessage from './components/element-error-message';
import cx from 'classnames';
import { GridYValue, GridYUnit } from '../../../constants';

export const RadiobuttonElement = function FromElement({ element, handlerChange, error, isPrint, formHasOnlyOneSubmitter }) {
  const isRequiredElement = useIsRequiredElement(element, formHasOnlyOneSubmitter);
  const { options, id: elementId } = element;
  const { alignment } = options ?? {};

  // Same as the checkbox field: with no group label of its own the required
  // mark rides the last option instead of floating on a blank line above the
  // field. See the comment in `elements/checkbox/index.jsx`.
  const hasGroupLabel = !!String(options.label ?? '').trim();
  const markRidesOption = isRequiredElement && !hasGroupLabel && element.inputs.length > 0;

  return (
    <div className={'element-wrapper radiobutton'}>
      <div className="element-inner">
        <label
          htmlFor={element.id}
          className="form-label w-full"
          style={{ zIndex: 5000 + (element.options.zIndex || 10), width: 'fit-content', position: 'relative' }}
        >
          {element.options.label} <span className="required">{isRequiredElement && !markRidesOption ? '*' : ''}</span>
        </label>
        <div className="form-control-radio-wrapper">
          {element.inputs.map((option, index) => {
            const { id: optionId } = option;
            const isChecked = element.options.valueInput === optionId;
            const inputLabelId = `${elementId}-${optionId}`;
            return (
              <div
                key={index}
                className={cx('form-control-radio element', {
                  [alignment]: alignment,
                  print: isPrint,
                  checked: isChecked,
                  [`form-control-radio-${element.options.size}`]: element.options.size,
                })}
                style={{
                  zIndex: 5000 + (element.options.zIndex || 10),
                  position: 'relative',
                }}
              >
                <label
                  className={'radiobutton-label'}
                  htmlFor={inputLabelId}
                  style={{ zIndex: 5000 + (element.options.zIndex || 10), width: 'fit-content', position: 'relative', fontFamily: 'Arial' }}
                >
                  {!isPrint && (
                    <input
                      id={inputLabelId}
                      name={element.options.label}
                      type="radio"
                      value={optionId}
                      checked={isChecked}
                      onChange={() => handlerChange(element, optionId)}
                    />
                  )}
                  <span
                    className={cx('radiobutton-button', { checked: isChecked })}
                    style={{ zIndex: 5000 + (element.options.zIndex || 10), position: 'relative' }}
                  />
                  {option.label}
                  {markRidesOption && index === element.inputs.length - 1 && <span className="required">*</span>}
                </label>
              </div>
            );
          })}
        </div>
        <ElementErrorMessage message={error} />
      </div>
      {element.options.instructions && <p className="instructions">{element.options.instructions}</p>}
    </div>
  );
};
